import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio, Input, Select } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { updateCityType } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class EditCityType extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sortTypeOption:JSON.parse(window.sessionStorage.getItem('sortTypeOption')),
      internationalization: this.props.intl.messages.EditOrAddTenceCom,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //巡检费用数值判断，设备型号长度判断
        if (values.deviceModel.length > 50)
        {
          message.error('公司名称最大长度不能超过50个字符');
          return;
        }
       
        this.setState({
          btnLoading: true,
        });
        if (!this.props.stubId || this.props.stubId == null)
        {
          
        } else {
          values.companyId = this.props.stubId.cityId;
        }
        fetchHandler(updateCityType, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 30 },
        sm: { span: 15, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
       

          <FormItem {...formItemLayout} disabled label={'城市名称'}>
              {getFieldDecorator("deviceModel", {
                rules: [
                  {
                    required: true,
                    message: "请输入城市名称",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.cityName,
              })(<Input disabled/>)}
          </FormItem>

          <FormItem  {...formItemLayout} label='城市类别'>
            {getFieldDecorator("infoType", {
              rules: [
                {
                  required: true,
                  message: '请选择城市类别', // "请选择城市类别"
                },
              ],
              initialValue: this.props.stubId == null ? '1' : this.props.stubId.cityType + '',
            })(
              <Radio.Group>
                <Radio key="1" value="1">A类</Radio>
                <Radio key="2" value="2">B类</Radio>
                <Radio key="3" value="3">C类</Radio>
              </Radio.Group>,
              )}
          </FormItem>

          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const EditOrAddTenceCom = Form.create()(EditCityType);

export default injectIntl(EditOrAddTenceCom);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/editCityType.js